export const baseURL = "https://wheel.nawarliveapp.top/";
export const adminBaseURL = "https://portal.nawarliveapp.top/";
export const key = "AauCc3J0rXzqlqJvJkLMzg";
